import { MutationTree } from 'vuex';
import { DigitalState, Digital } from './digital-types';

export const mutations: MutationTree<DigitalState> = {
  setDigitalInState(state, payload: Digital) {
    state.error = false;
    state.digital = payload;
  },
  profileError(state) {
    state.error = true;
    state.digital = undefined;
  },
};
